import { render, staticRenderFns } from "./AblFrictionTest.vue?vue&type=template&id=5b91c8e9&"
import script from "./AblFrictionTest.vue?vue&type=script&lang=js&"
export * from "./AblFrictionTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports